<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('signature.pageTitle') }}</h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row form-group">
            <label class="col-md-2 col-form-label required">{{ $t('signature.position') }}</label>
            <div class="col-md-3">
              <input
                v-model.trim="model.position"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('position') }"
              />
              <div class="invalid-feedback" v-if="errors.has('position')">{{ errors.first('position') }}</div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-2 col-form-label required">{{ $t('signature.signBy') }}</label>
            <div class="col-md-3">
              <input
                v-model.trim="model.sign_by"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('sign_by') }"
              />
              <div class="invalid-feedback" v-if="errors.has('sign_by')">{{ errors.first('sign_by') }}</div>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-2 col-form-label required">{{ $t('signature.signatureFile') }}</label>
            <div class="col-md-3">
              <ts-button color="primary" @click="$refs.file.click()">{{ $t('signature.browseFile') }}</ts-button>
              <input
                type="file"
                ref="file"
                style="display:none"
                accept="image/x-png, image/gif, image/jpeg"
                @change="onFileChange"
              />
              <div class="text-danger" v-if="errors.has('sign_by')">{{ errors.first('file') }}</div>
              <img id="signature" :src="priview" alt />
            </div>
          </div>
          <div class="row form-group">
            <label class="col-md-2"></label>
            <div class="col-md-3 text-right">
              <ts-button v-if="!model.id > 0" :waiting="waiting" @click="onSave" color="primary">{{
                $t('button.save')
              }}</ts-button>
              <ts-button v-else :waiting="waiting" @click="onUpdate" color="primary">{{
                $t('button.update')
              }}</ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'signature',
  data() {
    return {
      model: {
        id: 0,
        position: '',
        sign_by: '',
        signature_file: '',
        file: ''
      },
      errors: new Errors(),
      priview: 'https://cdn.pixabay.com/photo/2012/04/11/11/16/signature-27485_960_720.png',
      waiting: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/signature', ['resources'])
  },
  methods: {
    onFileChange(e) {
      let file = e.target.files[0]
      if (file instanceof File || file instanceof Blob) {
        this.model.file = file
      }

      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.priview = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        }
      }
    },
    fetchData() {
      this.$store.dispatch('hr/signature/fetch').then(() => {
        if (this.resources.length > 0) {
          this.model.id = this.resources[0].id
          this.model.position = this.resources[0].position
          this.model.sign_by = this.resources[0].sign_by
          this.model.signature_file = this.resources[0].signature_file
          this.priview = this.resources[0].signature_file + '&api_token=' + this.$store.getters.accessToken
        }
      })
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      let formData = new FormData()
      formData.append('position', this.model.position)
      formData.append('sign_by', this.model.sign_by)
      formData.append('signature_file', this.model.signature_file)
      formData.append('file', this.model.file)
      this.$store
        .dispatch('hr/signature/store', formData)
        .then(response => {
          this.$refs.file.value = ''
          this.model.file = ''
          this.fetchData()
          this.$toasted.success(response.message)
          this.errors = new Errors()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      let formData = new FormData()
      formData.append('id', this.model.id)
      formData.append('position', this.model.position)
      formData.append('sign_by', this.model.sign_by)
      formData.append('signature_file', this.model.signature_file)
      formData.append('file', this.model.file)
      this.$store
        .dispatch('hr/signature/update', formData)
        .then(response => {
          this.$toasted.success(response.message)
          this.$refs.file.value = ''
          this.model.file = ''
          this.fetchData()
          this.errors = new Errors()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
#signature {
  height: 100px;
  margin: 16px 0;
}
</style>
